/* ==========================================================================
   ELEGIR LA VERSIÓN DESDE CUALQUIER TARJETA  (16-sep-2026 · corregido el 17)

   La casa, el 16: «los botones de 50 y 100 ml en las vistas de catálogo —y las demás, menos
   la individual de producto que sí funciona— solo abren la ficha, no sirven para elegir la
   versión y añadirla al carrito sin salir».
   La casa, el 17: «los botones de 50 y 100 ml del catálogo abren el carrito, pero no hacen
   la selección».

   Tenía razón: la primera versión AGREGABA de golpe al tocar la pastilla, y el botón
   «Agregar al carrito» de la tarjeta seguía mandando los 100 ml, así que quien elegía 50 y
   luego pulsaba el botón terminaba con dos renglones. Ahora se comporta como la ficha:

     · tocar una pastilla ELIGE esa versión y se queda marcada (no agrega, no abre el cajón)
     · «Agregar al carrito» mete la versión elegida; si no se eligió ninguna, la de siempre

   Las pastillas se pintan en varios lugares (catálogo, temporada, recomendaciones de la
   encuesta) y cada uno tiene su generador. En vez de tocarlos todos, esto escucha el clic UNA
   vez, en captura, y no deja que el clic siga hasta la tarjeta, que es lo que abría la ficha.

   Se queda fuera de:
     · la ficha de producto (.pagina), que ya tiene sus propios botones de talla y sus
       tarjetas de similares, que ya eligen bien;
     · el carrusel de lanzamientos (#pv5t), que resuelve lo suyo con data-addt.

   Se genera y se sube con CARRITO/subir_carrito.py. No editar en el tema.
   ========================================================================== */
(function(){
  'use strict';

  function talla(pz){
    if(pz.classList.contains('pz-50')) return '50';
    if(pz.classList.contains('pz-100')) return '100';
    var t = (pz.textContent || '').replace(/\s+/g, ' ');
    return /50\s*ml/i.test(t) ? '50' : (/100\s*ml/i.test(t) ? '100' : null);
  }

  function precio(pz){
    var b = pz.querySelector('b') || pz;
    var n = parseInt(String(b.textContent || '').replace(/[^\d]/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  /* la tarjeta que envuelve la pastilla, con el nombre que el carrito entiende */
  function tarjetaDe(el){
    if(!el || !el.closest) return null;
    var t = el.closest('[data-name]');
    if(t && t.getAttribute('data-name')) return t;
    t = el.closest('.cat-card, .card, article');
    if(!t) return null;
    var h = t.querySelector('h3[data-sku], h3, .cat-name, .nm');
    if(h && (h.textContent || '').trim()){
      t.setAttribute('data-name', h.textContent.trim());
      return t;
    }
    return null;
  }

  function fuera(el){
    return !!(el.closest('.pagina') || el.closest('#pv5t') || el.hasAttribute('data-addt'));
  }

  /* deja marcada la versión elegida, como hace la ficha con sus botones de talla */
  function elegir(pz, card){
    var todas = card.querySelectorAll('.pz');
    for(var i = 0; i < todas.length; i++) todas[i].classList.remove('pz-sel');
    pz.classList.add('pz-sel');
    card.setAttribute('data-tl-sel', talla(pz));
    card.setAttribute('data-precio-sel', precio(pz));
  }

  function agregar(card){
    var C = window.VelantisCart;
    if(!C || !C.add) return false;
    var nombre = (card.getAttribute('data-name') || '').trim();
    var tl = card.getAttribute('data-tl-sel');
    if(!nombre || !tl) return false;
    C.add({name: nombre, price: parseInt(card.getAttribute('data-precio-sel'), 10) || 0, talla: tl,
           img: card.getAttribute('data-img') || '',
           sub: card.getAttribute('data-sub') || ''});
    return true;
  }

  /* Va en `window` y en captura, y este archivo se carga ANTES que el catálogo: así el clic
     pasa por aquí antes que por el manejador que abre la ficha o que agrega la talla de
     siempre. Si se registrara después, el catálogo ya habría actuado. */
  window.addEventListener('click', function(e){
    if(!e.target || !e.target.closest) return;

    /* 1 · la pastilla elige la versión */
    var pz = e.target.closest('.pz');
    if(pz && !fuera(pz)){
      var card = tarjetaDe(pz);
      if(!card || !talla(pz)) return;
      e.preventDefault();
      e.stopPropagation();
      if(e.stopImmediatePropagation) e.stopImmediatePropagation();
      elegir(pz, card);
      return;
    }

    /* 2 · el botón de la tarjeta agrega lo elegido */
    var bt = e.target.closest('.add, [data-add], .cat-add, .btn-add');
    if(bt && !fuera(bt)){
      var c2 = tarjetaDe(bt);
      if(!c2 || !c2.getAttribute('data-tl-sel')) return;   /* sin elección, que siga su curso */
      e.preventDefault();
      e.stopPropagation();
      if(e.stopImmediatePropagation) e.stopImmediatePropagation();
      if(!agregar(c2)) return;
      bt.classList.add('pz-puesta');
      setTimeout(function(){ bt.classList.remove('pz-puesta'); }, 1200);
    }
  }, true);

  /* que se noten pulsables y que se vea cuál quedó elegida */
  var hoja = document.createElement('style');
  hoja.textContent =
    '.cat-price .pz,.price .pz{cursor:pointer}' +
    '.cat-price .pz:hover,.price .pz:hover{filter:brightness(1.06)}' +
    '.pz.pz-sel{background:#8A6D1F;border-color:#8A6D1F;color:#fff;box-shadow:0 0 0 1px #8A6D1F}' +
    '.pz.pz-sel b,.pz.pz-sel i{color:#fff}' +
    '.pz.pz-puesta{outline:2px solid #8A6D1F;outline-offset:1px}';
  document.head.appendChild(hoja);
})();
